import { render, staticRenderFns } from "./RedistributionClient.vue?vue&type=template&id=17464c3c&scoped=true&"
import script from "./RedistributionClient.vue?vue&type=script&lang=js&"
export * from "./RedistributionClient.vue?vue&type=script&lang=js&"
import style0 from "./RedistributionClient.vue?vue&type=style&index=0&id=17464c3c&scoped=true&lang=less&"
import style1 from "./RedistributionClient.vue?vue&type=style&index=1&id=17464c3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17464c3c",
  null
  
)

export default component.exports